/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The NftGeneratorControllerDtoRemoveNftUidIndexRequest model module.
 * @module model/NftGeneratorControllerDtoRemoveNftUidIndexRequest
 * @version 1.0
 */
class NftGeneratorControllerDtoRemoveNftUidIndexRequest {
    /**
     * Constructs a new <code>NftGeneratorControllerDtoRemoveNftUidIndexRequest</code>.
     * @alias module:model/NftGeneratorControllerDtoRemoveNftUidIndexRequest
     */
    constructor() { 
        
        NftGeneratorControllerDtoRemoveNftUidIndexRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NftGeneratorControllerDtoRemoveNftUidIndexRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NftGeneratorControllerDtoRemoveNftUidIndexRequest} obj Optional instance to populate.
     * @return {module:model/NftGeneratorControllerDtoRemoveNftUidIndexRequest} The populated <code>NftGeneratorControllerDtoRemoveNftUidIndexRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NftGeneratorControllerDtoRemoveNftUidIndexRequest();

            if (data.hasOwnProperty('seal')) {
                obj['seal'] = ApiClient.convertToType(data['seal'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NftGeneratorControllerDtoRemoveNftUidIndexRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NftGeneratorControllerDtoRemoveNftUidIndexRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['seal'] && !(typeof data['seal'] === 'string' || data['seal'] instanceof String)) {
            throw new Error("Expected the field `seal` to be a primitive type in the JSON string but got " + data['seal']);
        }

        return true;
    }


}



/**
 * @member {String} seal
 */
NftGeneratorControllerDtoRemoveNftUidIndexRequest.prototype['seal'] = undefined;






export default NftGeneratorControllerDtoRemoveNftUidIndexRequest;

